import ReportService from '../../service/ReportService'

const initialState = {
    fields: [],
    fieldsCount: 0,
    fieldsTableOptions: {},
    stations: [],
    stationsCount: 0,
    stationsTableOptions: {},
}

export default {
    namespaced: true,
    state: { ...initialState },
    actions: {
        async generateCsvFile({ commit }, payload) {
            try {
                await ReportService.generateCsv(payload)
            } catch (e) {
                console.log(e)
            }
        },

        async getFieldsData({ commit, state }) {
            try {
                let params = {
                    page: state?.fieldsTableOptions?.page ? state?.fieldsTableOptions?.page : 1,
                    itemsPerPage: state?.fieldsTableOptions?.itemsPerPage
                        ? state?.fieldsTableOptions?.itemsPerPage
                        : 10,
                    type: 'fields',
                }
                commit('setLoading', true)
                let resp = await ReportService.getCsvRows(params)

                if (resp.status === 200) {
                    commit('setFields', resp?.data?.probes)
                    commit('setFieldsCount', resp?.data?.probes_count)
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },
        async getStationsData({ commit, state }) {
            try {
                let params = {
                    page: state?.fieldsTableOptions?.page ? state?.fieldsTableOptions?.page : 1,
                    itemsPerPage: state?.fieldsTableOptions?.itemsPerPage
                        ? state?.fieldsTableOptions?.itemsPerPage
                        : 10,
                    type: 'stations',
                }
                commit('setLoading', true)
                let resp = await ReportService.getCsvRows(params)

                if (resp.status === 200) {
                    commit('setStations', resp?.data?.probes)
                    commit('setStationsCount', resp?.data?.probes_count)
                }
                commit('setLoading', false)
            } catch (e) {
                console.log(e)
                commit('setLoading', false)
            }
        },

        async downloadCsvFile({ commit }, rowId) {
            try {
                let resp = await ReportService.getCsvFile(rowId)
                if (resp.status === 200) {
                    return resp.data
                }
            } catch (e) {
                console.log(e)
            }
            return null
        },
    },
    mutations: {
        setFields(state, value) {
            state.fields = value
        },
        setFieldsCount(state, value) {
            state.fieldsCount = value
        },
        setFieldsTableOptions(state, value) {
            state.fieldsTableOptions = value
        },
        setStations(state, value) {
            state.stations = value
        },
        setStationsCount(state, value) {
            state.stationsCount = value
        },
        setStationsTableOptions(state, value) {
            state.stationsTableOptions = value
        },
    },
}
